import { memo } from 'react';
import {
  TooltipTrigger as RACTooltipTrigger,
  TooltipTriggerComponentProps as RACTooltipTriggerProps,
} from 'react-aria-components';

export type TooltipTriggerProps = RACTooltipTriggerProps;

const ITooltipTrigger = ({ children, delay = 300, ...rest }: TooltipTriggerProps) => {
  return (
    <RACTooltipTrigger delay={delay} {...rest}>
      {children}
    </RACTooltipTrigger>
  );
};

export const TooltipTrigger = memo(ITooltipTrigger) as typeof ITooltipTrigger;
